import { useDirectoryOptions } from 'lib/core/hooks'

interface Props {
  countryCode: string | undefined
}

export const DISABLED_REGIONS = ['AA', 'AK', 'AE', 'AP', 'AS', 'FM', 'GU', 'HI', 'MH', 'MP', 'PW', 'PR', 'VI']

export const useShippingRegionOptions = ({ countryCode }: Props) => {
  const { regionOptions } = useDirectoryOptions({ countryCode })
  const shippingRegionOptions = regionOptions.filter(option => !DISABLED_REGIONS.includes(option.value))

  return {
    shippingRegionOptions
  }
}
